import styled from 'styled-components'
import { MEDIA_WIDTHS } from '../../../../themes'

export const Wrapper = styled.div`
  border: 1px solid #cbcbcb;
  border-radius: 8px;
  padding: 24px 8px;
  margin-top: 30px;
  position: relative;
`

export const Title = styled.div`
  position: absolute;
  top: -0.5lh;
  left: 1em;
  padding-inline: 0.5em;
  background-color: #fff;
  font-weight: 600;
`
export const TimeWrapper = styled.div`
    display: grid;
    place-content: center;

    .time-box {
      display: grid;
      gap: 1rem;
      grid-template:
        "total jobnare jobnavi"
        / auto auto auto;

      @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        grid-template:
          "total total"
          "jobnare jobnavi"
          / auto auto;
      }
    }

    .time {
      display: flex;
      justify-content: center;
      align-items: end;
      gap: 4px;
      color: #8a8a8a;
      padding: 1rem 2rem;
      border-radius: 6px;

      .label {
        color: ${({ theme }) => theme.success};
        align-self: center;
        font-weight: bold;
      }

      .number {
        font-size: 24px;
        font-weight: bold;
        color: #000;
      }
    }

    .total {
      grid-area: total;
      background-color: ${({ theme }) => theme.green_light};

      .label {
        font-size: 24px;
      }
    }

    .jobnare {
      grid-area: jobnare;
    }

    .jobnavi {
      grid-area: jobnavi;
    }


`
